/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Stack, Checkbox, Text } from '@chakra-ui/core';
import React, { useMemo, useState, useCallback } from 'react';
import { findItemById, isFieldSchema } from '../utils';
import { findSiblings } from '../hooks/useFindSiblings';
import { useUpdateFormItem } from '../hooks/useUpdateFormItem';
import { getParentId } from '../hooks/useGetParent';
import { FormBuilderComponentProps, FormFieldT } from '../types';
import { useStoreState } from '../../../../models/hooks';
import theme from '../../../../styles/customTheme';
import { COMPONENT_FIELDS } from '../schemas/formComponentFieldSchema';
import { FORM_ADVANCED_SECTIONS } from '../schemas/formAdvancedSections';
import { FORM_COMPONENT_BASIC_INPUT_TYPE } from '../schemas/formComponentInputTypeSchema';

function CheckBoxDisableFieldComponent({ fieldId }: Pick<FormBuilderComponentProps, 'fieldId'>) {
  const handleOnChange = useUpdateFormItem();
  const formSchema = useStoreState((state) => state.formBuilder.formSchema);
  const currentLanguage = useStoreState((state) => state.formBuilder.currentLanguage);

  const field = React.useMemo(() => findItemById(formSchema, fieldId) as FormFieldT, []);

  const siblingFields = React.useMemo(() => {
    return findSiblings(formSchema, fieldId, true, field?.isFollowUp);
  }, [formSchema, fieldId, field]);

  const initialIsChecked = useMemo(() => {
    if (!isFieldSchema(field!)) return false;
    return !siblingFields
      ?.filter((s) => s?.disabledId === field.disabledId && !s?.isFrontEndOnly)
      ?.every((sibling) => sibling.disabledId === field.disabledId && sibling.disabled);
  }, [field, siblingFields]);

  const [isChecked, setIsChecked] = useState(initialIsChecked);

  React.useEffect(() => {
    setIsChecked(initialIsChecked);
  }, [initialIsChecked]);

  const parentId = React.useCallback(() => getParentId(formSchema, fieldId, null), []);

  const handleCheckboxChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newCheckedState = e.target.checked;
      setIsChecked(newCheckedState);

      if (!isFieldSchema(field!)) {
        console.warn('Checkbox change handled but field is not a valid FieldSchema at the time of callback execution.', field);
        return;
      }

      const linkedDisableId = field.disabledId;
      const currentSection = field.section;

      const updatedFields = siblingFields.map((sibling) => {
        const updatedSibling = { ...sibling };

        if (currentSection === FORM_ADVANCED_SECTIONS.sin && updatedSibling.field === COMPONENT_FIELDS.socialInsuranceNumber) {
          return { ...updatedSibling, enableWorkPermit: newCheckedState };
        }
        if (
          linkedDisableId &&
          linkedDisableId === updatedSibling.disabledId &&
          updatedSibling.inputType !== FORM_COMPONENT_BASIC_INPUT_TYPE.checkboxDisable &&
          !updatedSibling.isFrontEndOnly
        ) {
          return { ...updatedSibling, disabled: !newCheckedState };
        }
        return updatedSibling;
      });

      if (parentId()) {
        handleOnChange(parentId()!, { fields: [...updatedFields] });
      } else {
        console.warn('No parentId found for field:', fieldId, 'Cannot update sibling fields via parent.');
      }
    },
    [field, siblingFields, parentId, handleOnChange],
  );

  const labelText = useMemo(() => {
    if (!isFieldSchema(field!)) return '';
    return field?.text?.[currentLanguage] || '';
  }, [field, currentLanguage]);

  if (!isFieldSchema(field!)) {
    return null;
  }

  return (
    <Stack>
      <Checkbox isChecked={isChecked} onChange={handleCheckboxChange} size="sm">
        <Text fontSize="sm" color={isChecked ? theme.colors.gray[400] : 'inherit'}>
          {labelText}
        </Text>
      </Checkbox>
    </Stack>
  );
}

export const CheckBoxDisableField = React.memo(CheckBoxDisableFieldComponent, (prev, next) => prev.fieldId === next.fieldId);
